import { ADMIN_DASHBOARD_COPY } from '@sonar-software/sonar-ts-constants';
import arovyIcon from 'images/Key.svg';
import azureIcon from 'images/azure-icon.svg';
import googleIcon from 'images/google-icon.svg';
import oktaIcon from 'images/okta-icon.svg';
import oneLoginIcon from 'images/onelogin-icon.svg';
import { QuestionCircleFilled } from '@ant-design/icons';
import React from 'react';
import { Tooltip } from 'antd';
import { UserIssuerType } from '@sonar-software/sonar-core';

export const userIssuerTooltip: Record<UserIssuerType, string> = {
	azure: ADMIN_DASHBOARD_COPY.ISSUED_BY_AZURE,
	google: ADMIN_DASHBOARD_COPY.ISSUED_BY_GOOGLE,
	okta: ADMIN_DASHBOARD_COPY.ISSUED_BY_OKTA,
	onelogin: ADMIN_DASHBOARD_COPY.ISSUED_BY_ONELOGIN,
	sonar: ADMIN_DASHBOARD_COPY.PASSWORD,
	unknown: ''
};

export const userIssuerIconImageSrc: Record<UserIssuerType, string> = {
	azure: azureIcon,
	google: googleIcon,
	okta: oktaIcon,
	onelogin: oneLoginIcon,
	sonar: arovyIcon,
	unknown: ''
};

export interface UserIssuerIconProps {
	issuerType: UserIssuerType;
}

export const UserIssuerIcon: React.FC<UserIssuerIconProps> = ({ issuerType }) => {
	if (issuerType === null || issuerType === undefined) {
		return null;
	}

	const title = userIssuerTooltip[ issuerType ] ?? ADMIN_DASHBOARD_COPY.UNKNOWN_ISSUER;
	const iconSrc = userIssuerIconImageSrc[ issuerType ];

	return (
		<span className='user-issuer-icon'>
			<Tooltip
				placement='bottom'
				title={ title }>
				<div>
					{ iconSrc ? <img src={ iconSrc } /> : <QuestionCircleFilled /> }
				</div>
			</Tooltip>
		</span>
	);
};
